import React from "react";
import { withRouter } from 'react-router-dom'

//HELPERS
import * as c from '../../../helpers/constants'
import { callApi } from '../../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import { Row, Column, IBox, Button } from '../../inspinia'
import ModalPreview from '../../campanha/modalPreview'
import ModalSendTest from '../../campanha/modalSendTest'
import { templateAction } from '../../../store/templateSMS';
import TemplateList from '../listaTemplate/index';
import { campanhaAction } from '../../../store/campanha';
import UrlCampanhaSms from "../../campanhaSms/urlCampanhaSms";

class TemplateSMS extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state =
        {
            loading: false,
            form: this.formInitialState(),
            modalPreviewIsOpen: false,
            modalSendTestIsOpen: false,
            templates: [],

            emailUsuario: this.props.auth.user.email,
            usuario: {},
            auth: this.props.auth,
            posicaomouse1: [],
            posicaomouse2: [],
            tipoSalvar: "",
            templateAntigo: "",
            hiddenEditor: true,
            removeAnexo: false,
            maxLength: "135",
            

            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
        }

        this.handleChangeTextArea = this.handleChangeTextArea.bind(this);
        this.handleChangeUrl = this.handleChangeUrl.bind(this);
        this.handlePreviewToggle = this.handlePreviewToggle.bind(this);
        this.handleTestToggle = this.handleTestToggle.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.click = this.click.bind(this);
        this.insereTemplate = this.insereTemplate.bind(this);
        this.onClickCancelar = this.onClickCancelar.bind(this);
        this.handleNovoTemplate = this.handleNovoTemplate.bind(this);
        this.RecuperarTemplates = this.RecuperarTemplates.bind(this);
        this.validacaoLimiteTextArea = this.validacaoLimiteTextArea.bind(this);

        this.state.usuario['email'] = this.state.emailUsuario;

    }

    formInitialState() {
        return {
            id: "",
            template: [],
            campanha: {}
        }
    }

    componentDidMount() {
        this.RecuperarTemplates();
    }

    insereTemplate(states, id, comp) {
        let self = this;

        comp.preventDefault();

        const url = `${c.API_BASE_URL}/template-carimbo-tempo/sms/${id}`;
        const options =
        {
            method: 'GET'
            , headers: { 'Content-Type': 'application/json' }
        };

        callApi(url, options, function (response) {
            self.setState({ ...self.state, form: response, hiddenEditor: false });
            self.validacaoLimiteTextArea();
        });

    }

    RecuperarTemplates() {
        let self = this;

        const url = `${c.API_BASE_URL}/template-carimbo-tempo/sms`;
        const options = self.state.optionsGet;

        callApi(url, options, function (response) {
            self.setState({ ...self.state, templates: response });
        });
    }

    handlePreviewToggle(e) {
        this.setState({ ...this.state, modalPreviewIsOpen: !this.state.modalPreviewIsOpen });
    }

    handleTestToggle(e) {
        this.setState({ ...this.state, modalSendTestIsOpen: !this.state.modalSendTestIsOpen });
    }

    handleSave(e) {
        e.preventDefault();
        
        if (this.state.loading) return;

        this.state.form.auth = this.state.auth;
        let editor = 'html';

        this.props.actions.template.salvarTemplateCarimboSms(this.state.form, editor).then((response) => {
            if (response.status === "BAD_REQUEST") {
                c.TOASTER_SUCCESS(response.message);
                return;
            }

            if (response) {
                window.location.reload();
                c.TOASTER_SUCCESS("Template salvo com sucesso!");
            }

        }).catch((error) => {
            if (error.message) c.TOASTER(error.type, error.message); else c.TOASTER_ERROR(c.NETWORK_ERROR);
        });
    }

    click(campo) {
        var startPos = campo.target.selectionStart;
        var endPos = campo.target.selectionEnd;
        this.setState({ posicaomouse1: startPos, posicaomouse2: endPos });
    }

    handleChangeTextArea(e) {
        this.click(e);
        var texto = e.target.value;
        this.state.form.mensagem = texto;

        this.validacaoLimiteTextArea();
    }

    validacaoLimiteTextArea(){
        this.setState({maxLength:"135"});
    }

    handleChangeTextHtml(texto) {
        texto = texto.replace("tagselectorhtml:", "");
        this.state.form.mensagem = texto;
        this.setState({ posicaomouse1: 0, posicaomouse2: 0 });
    }

    handleChangeUrl(e) {
        this.click(e);
        var urlInput = e.target.value;
        this.state.form.url = urlInput;
    }

    onClickCancelar() {
        this.setState({
            ...this.state,
            form: {
                mensagem: "",
                id: "",
                template: [],
                campanha: {}

            },
            hiddenEditor: true,


        });
    }

    handleNovoTemplate() {
        this.setState({ ...this.state, hiddenEditor: false });
    }

    render() {
        const form = this.state.form;

        return (
            <div>
                <ModalPreview isOpen={this.state.modalPreviewIsOpen} toggle={this.handlePreviewToggle} preview={form.mensagem} />
                <ModalSendTest isOpen={this.state.modalSendTestIsOpen} toggle={this.handleTestToggle} />

                {/* {Lista de templates} */}
                <div hidden={!this.state.hiddenEditor}>
                    <Row className="mb-3">
                        <Column size="12">
                            <TemplateList
                                status={this.state}
                                templates={this.state.templates}
                                onClick={this.insereTemplate}
                                novoTemplate={this.handleNovoTemplate}
                                history={this}
                                recarregar={true}
                            />
                        </Column>
                    </Row>
                </div>

                {/* { Editor HTML } */}
                <div hidden={this.state.hiddenEditor}>
                    {/* TITLE */}
                    <Row className="mb-4">
                        <Column size="3">
                            <h2 className="fs-20 fw-600 text-body m-0">Mensagem SMS</h2>
                        </Column>
                        <Column size="9">
                            <div className="input-group d-block fs-14 text-right">
                                <button name="salvar" onClick={this.handleSave} type="button" className="btn btn-link px-3">Salvar</button>
                            </div>
                        </Column>
                    </Row>

                    {/* FORM */}
                    <Row className="mb-3">
                        <Column size="9">
                            <IBox className="mb-0">
                                <div>
                                    <label>Título da mensagem</label>
                                </div>
                                <div>
                                    <label className="fs-20 fw-600 text-body m-0">{this.state.form.campanha.descricao}</label>
                                </div>

                                <label className='mt-3'>Corpo do Template SMS</label>

                                {/* Editor here */}
                                <div>
                                    <textarea rows="12" cols="40" maxLength={this.state.maxLength} value={this.state.form.mensagem} onChange={this.handleChangeTextArea} onClick={this.click} />
                                    <small className="form-text text-muted">
                                        <i className="fa fa-info-circle" style={{ fontSize: "15px" }}></i>
                                        <br />A quantidade máxima de caracteres será de <strong>135 caracteres.</strong>
                                    </small>
                                </div>
                            </IBox>
                        </Column>
                    </Row>
                    <Row>
                        <Column size="3">
                            <Button className="btn btn-danger" onClick={this.onClickCancelar}>Cancelar</Button>
                        </Column>
                    </Row>
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch) {
    return { actions: { template: bindActionCreators(templateAction, dispatch), arquivo: bindActionCreators(campanhaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TemplateSMS));